export const LEGAL_AGE_QUEBEC = 18;
export const LEGAL_AGE_ONTARIO = 19;

export const calculateAgeTruncated = (birthday: Date, atDate?: Date): number => {
  if (!birthday) {
    throw new Error('Cannot calculate age without a birthday.');
  }

  // Handle date strings that weren't parsed after being returned from the server
  if (typeof birthday === 'string') {
    birthday = new Date(birthday);
  }
  if (atDate && typeof atDate === 'string') {
    atDate = new Date(atDate);
  }

  const baseDate = atDate ?? new Date();

  let age = baseDate.getFullYear() - birthday.getFullYear();
  const monthDiff = baseDate.getMonth() - birthday.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && baseDate.getDate() < birthday.getDate())) {
    age--;
  }

  return age;
};

export const normalizeAge = (ageInMonthsFloat: number): PossibleAges => {
  if (ageInMonthsFloat < 0) {
    return PossibleAges.BIRTH_TO_COME;
  } else if (ageInMonthsFloat >= 0 && ageInMonthsFloat < 12) {
    return PossibleAges.ZERO_TWELVE_MONTHS;
  } else {
    return Math.trunc(ageInMonthsFloat);
  }
};

export enum PossibleAges {
  BIRTH_TO_COME = 1,
  ZERO_TWELVE_MONTHS = 6,
  ONE = 12,
  TWO = 24,
  THREE = 36,
  FOUR = 48,
  FIVE = 60,
  SIX = 72,
  SEVEN = 84,
  EIGHT = 96,
  NINE = 108,
  TEN = 120,
  ELEVEN = 132,
  TWELVE = 144,
  THIRTEEN = 156,
  FOURTEEN = 168,
  FIFTEEN = 180,
  SIXTEEN = 192,
  SEVENTEEN = 204,
  EIGHTEEN = 216,
  NINETEEN = 228,
  TWENTY = 240,
  TWENTY_ONE = 252,
  TWENTY_TWO = 264,
  TWENTY_THREE = 276,
  TWENTY_FOUR = 288,
  TWENTY_FIVE_OR_MORE = 300,
}
